import PreviewSection from '../../PreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function EstimateVsActualHTMLPreviewGroupingSection() {}

EstimateVsActualHTMLPreviewGroupingSection.prototype = new PreviewSection()

EstimateVsActualHTMLPreviewGroupingSection.prototype.init = function(groupingLevelsArray, hasForthLevel, columnsStrategy, timeFormat, reportAuthorizationInfo) {
    PreviewSection.prototype.init.call(this)
    this.groupingLevelsArray = groupingLevelsArray
    this.hasForthLevel = hasForthLevel
    this.columnsStrategy = columnsStrategy
    this.timeFormat = timeFormat
    this.reportAuthorizationInfo = reportAuthorizationInfo

    return this
}

EstimateVsActualHTMLPreviewGroupingSection.prototype.levelClasses = ["firstLevel", "secondLevel", "thirdLevel", "forthLevel"]
EstimateVsActualHTMLPreviewGroupingSection.prototype.groupingClasses = ["firstGrouping", "secondGrouping", "thirdGrouping", "forthGrouping"]

EstimateVsActualHTMLPreviewGroupingSection.prototype.addRows = function(tBody) {
    this.addRowWithMainCell(tBody, this.message("report.budgeted_vs_actual.total_sc"), "totalRow", "totalValue")

    const length = this.groupingLevelsArray.length
    let levels

    if (length === 1) levels = [0, 0, 0, 0, 0, 0, 0, 0, 0]

    if (length === 2) {
        const lastLevelRows = this._getLastLevelRows(1)
        const firstRow = lastLevelRows.firstRow
        if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[1], [this.groupingLevelsArray[0]])) {
            const secondRow = lastLevelRows.secondRow
            levels = [0, firstRow, secondRow, 0, firstRow, secondRow, 0, firstRow, secondRow]
        } else {
            levels = [0, firstRow, 0, firstRow, 0, firstRow, 0, firstRow, 0]
        }
    }

    if (length === 3) {
        const lastLevelRows = this._getLastLevelRows(2)
        const firstRow = lastLevelRows.firstRow
        if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[2], this.groupingLevelsArray.slice(0, 2))) {
            const secondRow = lastLevelRows.secondRow
            levels = [0, 1, firstRow, secondRow, 0, 1, firstRow, secondRow, 0]
        } else {
            levels = [0, 1, firstRow, 0, 1, firstRow, 0, 1, firstRow]
        }
    }

    if (length > 3) {
        const lastLevelRows = this._getLastLevelRows(3)
        const firstRow = lastLevelRows.firstRow
        if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[3], this.groupingLevelsArray.slice(0, 3))
            && ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[2], this.groupingLevelsArray.slice(0, 2))) {
            const secondRow = lastLevelRows.secondRow
            levels = [0, 1, 2, firstRow, secondRow, 2, firstRow, secondRow, 0]
        }
        else {
            levels = [0, 1, 2, firstRow, 0, 1, 2, firstRow, 0]
        }
    }

    for (let i = 0; i < levels.length; ++i) this.addGroupingRow(tBody, levels[i])
}

EstimateVsActualHTMLPreviewGroupingSection.prototype._getLastLevelRows = function(defaultLevel) {
    const hasUserLevel = this.groupingLevelsArray[defaultLevel] === ReportGroupingLevel.USER
    const allUsersAvailable = this.reportAuthorizationInfo.allUsersAvailable
    const anyOtherUsersAvailable = this.reportAuthorizationInfo.anyOtherUsersAvailable
    const needSwitchToMe = hasUserLevel && !allUsersAvailable && !anyOtherUsersAvailable
    const firstRow = needSwitchToMe ? 4 : defaultLevel
    const needToShowOthers = hasUserLevel && !allUsersAvailable
    const secondRow = needToShowOthers ? 5 : defaultLevel
    return {
        firstRow: firstRow,
        secondRow: secondRow,
    }
}

EstimateVsActualHTMLPreviewGroupingSection.prototype.addGroupingRow = function(tBody, index) {
    const groupingType = this.groupingLevelsArray[index]
    let levelPreviewName
    if (index === 4) {
        levelPreviewName = this.message("report.common.me")
        index = this.groupingLevelsArray.length - 1
    } else if (index === 5) {
        levelPreviewName = this.message("report.common.others")
        index = this.groupingLevelsArray.length - 1
    } else {
        levelPreviewName = ReportPreviewUtils.getLevelPreviewName(groupingType)
    }

    // if this grouping level is the lowest and forth level is present, it means
    //  this grouping level is really forth (even if his index can be 1 or 2, because second and third level can be skipped).
    // in this case we should add css-class for forth grouping for this row, so grIndex must be 3.
    const grIndex = (index === this.groupingLevelsArray.length - 1) && this.hasForthLevel ? 3 : index

    this.addRowWithMainCell(tBody, levelPreviewName, this.groupingClasses[grIndex], this.levelClasses[index], groupingType)
}

EstimateVsActualHTMLPreviewGroupingSection.prototype.addRowWithMainCell = function(tBody, text, rowClassName, className, groupingType) {
    const row = this.createRow(rowClassName)
    this.addCell(row, text, className)
    this.addDataCells(row, groupingType)
    this.addRow(tBody, row)
}

EstimateVsActualHTMLPreviewGroupingSection.prototype.addDataCells = function(row, groupingType) {
    this.addTimeValueCell(row)
    if (groupingType && groupingType === ReportGroupingLevel.USER)
        this.columnsStrategy.addEmptyColumns(row)
    else
        this.columnsStrategy.addColumnValues(row)
}

EstimateVsActualHTMLPreviewGroupingSection.prototype.addTimeValueCell = function(row) {
    ReportPreviewUtils.addHTMLTimeValueCell(row, this.timeFormat)
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/eva/EstimateVsActualHTMLPreviewGroupingSection.js